import initializeComponent from 'Shared/react-initialize';
import Navigation from './navigation';

initializeComponent('CommunityNav', Navigation);
